/**
 * ListTagRulesPage constants
 * For Media Devoted | Created By Ciro Autiero
 */

import {
  DROP_LIST_FIELD_PREFIX,
  DROP_LIST_TAG_RULE_FIELDS,
  DROP_SOURCE_FIELD_PREFIX,
  DROP_SOURCE_TAG_RULE_FIELDS,
} from '@trafficpulse/shared';

// Deep import — see useListTagRules: the stats barrel circular-inits here.
import { VOLUUM_COLUMNS } from '@/features/smswiser-campaigns/components/SmswiserCampaignStatsTab/shared/constants';

/** Max rules per bulk import (must match backend BULK_MAX_RULES). */
export const BULK_MAX_RULES = 50;

export const LIST_METRIC_FIELDS = VOLUUM_COLUMNS.map((c) => ({ key: c.key, label: c.label }));

/** Drop-rule-only fields reading the drop's top source metrics (MD-1067 "+"). */
export const DROP_SOURCE_METRIC_FIELDS = DROP_SOURCE_TAG_RULE_FIELDS.map((key) => {
  const base = key.slice(DROP_SOURCE_FIELD_PREFIX.length);
  const col = VOLUUM_COLUMNS.find((c) => c.key === base);
  return { key: key as string, label: `Source ${col?.label ?? base}` };
});

/** Drop-rule-only fields reading the drop's LIST metrics (MD-1075). */
export const DROP_LIST_METRIC_FIELDS = DROP_LIST_TAG_RULE_FIELDS.map((key) => {
  const base = key.slice(DROP_LIST_FIELD_PREFIX.length);
  const col = VOLUUM_COLUMNS.find((c) => c.key === base);
  return { key: key as string, label: `List ${col?.label ?? base}` };
});

export const OPERATORS = [
  { op: 'gte' as const, label: '≥', title: 'Greater or equal' },
  { op: 'lte' as const, label: '≤', title: 'Less or equal' },
  { op: 'gt' as const, label: '>', title: 'Greater than' },
  { op: 'lt' as const, label: '<', title: 'Less than' },
  { op: 'eq' as const, label: '=', title: 'Equal' },
] as const;

export const TAG_COLOR_PRESETS = [
  '#22c55e', '#ef4444', '#3b82f6', '#f59e0b',
  '#06b6d4', '#8b5cf6', '#ec4899', '#6b7280',
] as const;

export const UNGROUPED_KEY = '__ungrouped__';
